import { team } from './team';
import { user } from './user';

export const richInlineNodes = {
	user,
	team,
};
